import React from 'react';
import { useBrand } from '../../../app/config/brand';
import { Icons } from '../../icons/Icons';

interface InfoBannerProps {
  children: React.ReactNode;
  variant?: 'info' | 'warning' | 'error';
}

export const InfoBanner: React.FC<InfoBannerProps> = ({ children, variant = 'info' }) => {
  const brand = useBrand();
  const colors = {
    info: { bg: brand.colors.bgAccent, border: brand.colors.info, text: brand.colors.info },
    warning: { bg: '#FEF3C7', border: brand.colors.warning, text: '#92400E' },
    error: { bg: '#FEE2E2', border: brand.colors.error, text: '#991B1B' },
  };
  const c = colors[variant];

  return (
    <div className="flex items-start gap-3 p-4 rounded-xl border" style={{ backgroundColor: c.bg, borderColor: c.border }}>
      <Icons.Info className="w-5 h-5 shrink-0 mt-0.5" style={{ color: c.text }} />
      <div className="text-sm" style={{ color: c.text }}>{children}</div>
    </div>
  );
};
